import { couplingPatterns } from '../constants/couplingPatterns';
export function addDummySignals(signals) {
    const newSignals = JSON.parse(JSON.stringify(signals));
    let nextAtomToAssign = signals.reduce((nextAtomToAssign, signal) => {
        const { atoms = [] } = signal;
        return Math.max(...atoms) > nextAtomToAssign
            ? Math.max(...atoms)
            : nextAtomToAssign;
    }, 0) + 1;
    signals.forEach((signal, s) => {
        const { js: jCouplings = [], atoms: signalAssignment = [nextAtomToAssign++], } = signal;
        const { newCouplings, tempSignals } = checkCouplings(jCouplings, signalAssignment, nextAtomToAssign + signals.length);
        if (tempSignals.length > 0)
            newSignals.push(...tempSignals);
        newSignals[s].js = newCouplings;
        newSignals[s].atoms = signalAssignment;
    });
    return newSignals.sort((a, b) => a.delta - b.delta);
}
function checkCouplings(jCouplings, signalAssignment, nextAtomToAssign) {
    const tempSignals = [];
    const newCouplings = jCouplings.reduce((newCouplings, jCoupling) => {
        const { atoms = [], multiplicity, coupling } = jCoupling;
        if (atoms.length === 0) {
            if (coupling && multiplicity) {
                const tempCouplings = [];
                const nbLinks = couplingPatterns.indexOf(multiplicity);
                for (let i = 0; i < nbLinks; i++) {
                    nextAtomToAssign++;
                    tempCouplings.push({
                        coupling,
                        atoms: [nextAtomToAssign],
                    });
                    tempSignals.push(formatSignal(coupling, [nextAtomToAssign], signalAssignment));
                }
                newCouplings.push(...tempCouplings);
            }
            else {
                newCouplings.push(jCoupling);
            }
        }
        return newCouplings;
    }, []);
    return { newCouplings, tempSignals };
}
function formatSignal(coupling, newSignalAssignment, signalAssignment) {
    return {
        delta: 100000,
        atoms: newSignalAssignment,
        js: [
            {
                coupling,
                atoms: signalAssignment,
            },
        ],
    };
}
//# sourceMappingURL=addDummySignals.js.map